import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import useStyles from "./calendar-day.style";
import "moment/locale/hu";

interface OcCalendarDayProps {
  date?: string;
  loading: boolean;
  hours?: boolean;
  unPaidDate: boolean;
}

export const OcCalendarDay: React.FC<OcCalendarDayProps> = ({
  date,
  loading,
  hours,
  unPaidDate
}) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  if (loading) return <div className={classes.loading} />;

  let locale = i18n.language.substr(0, 2).toLowerCase();
  let day = date ? new Date(date).getDate() : "";
  let month = date ? moment(new Date(date)).locale(locale).format("MMM") : "";

  if (unPaidDate) {
    return (
      <div className={classes.rootHours}>
        <div className={classes.month}>{t("OC_HOUR")}</div>
        <div className={classes.day}>00:00</div>
      </div>
    );
  }

  if (hours) {
    return (
      <div className={classes.rootHours}>
        <div className={classes.month}>{t("OC_HOUR")}</div>
        <div className={classes.day}>{date}</div>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.month}>{month}</div>
      <div className={classes.day}>{day}</div>
    </div>
  );
};

export default OcCalendarDay;
